module.exports = __webpack_public_path__ + "img/left-arrow2.ad129db7.svg";